import './styles.scss'
import React, { useRef, useState } from 'react'
import { I18n } from 'react-redux-i18n'
import ClickOutHandler from 'react-onclickout'

import composerActions from 'redux/actions/conversations/composerAct'
import SubjectsOptions from './SubjectsOptions'
import Subject from './Subject'
import Nixi1Spinner from 'components/Nixi1Spinner'
import { getStaticImage } from 'utils/statics'

const Subjects = ({
  conversationUser,
  getSubjects,
  loadingSubjects,
  setSubjectsIsOpen,
  subjectsIsOpen,
  composer,
  dispatch,
  setFilterValues,
  setIsSubjectFiltered,
  subjectsFilterOptions,
  filterValues,
  openOutboundAction,
  subjects,
  handleSelectSubject,
  handleStateSubject,
  handleReadSubject,
  handleMnemonicSubject,
  statesOptions,
  chatmailCheckedSubjects,
  chatmailAllCheckedSubjects,
  setChatmailCheckedSubjects,
  handleAllCheckedSubjects,
  handleChangeMultipleSubjects,
  handleDeleteSubject
}) => {
  const [isOpenRemoveModal, setIsOpenRemoveModal] = useState(false)
  const menuRef = useRef(null)

  const toggleRemoveModal = () => setIsOpenRemoveModal(!isOpenRemoveModal)

  const scrollToBottom = (element) => {
    element.scroll({
      top: element.scrollHeight,
      behavior: 'smooth'
    })
  }

  if (!loadingSubjects.isFirstFetching) return <Nixi1Spinner width='20px' height='20px' />

  return (
    <div className='chat-composer__subjects'>
      <div className='chat-composer__subjects-header-container'>
        <div className='chat-composer__subjects-header' onClick={() => setSubjectsIsOpen(!subjectsIsOpen)}>
          <p>{composer.currentSubject?.name}</p>
        </div>
        {composer.currentSubject && Object.keys(composer.currentSubject).length > 0 && (
          <i
            className='fa fa-times'
            onClick={() => {
              dispatch(composerActions.setCurrentSubject({}))
              setSubjectsIsOpen(false)
              setFilterValues(prevState => ({ ...prevState, text: '' }))
              setIsSubjectFiltered(false)
            }}
          ></i>
        )}
        <i className={`fa fa-chevron-${subjectsIsOpen ? 'up' : 'down'}`} onClick={() => setSubjectsIsOpen(!subjectsIsOpen)}></i>
      </div>
      {subjectsIsOpen && (
        <ClickOutHandler onClickOut={() => !isOpenRemoveModal && setSubjectsIsOpen(false)}>
          <div className={`chat-composer__subjects-menu ${composer.currentSubject?.name ? 'with-data' : ''}`} >
            <SubjectsOptions
              type={['checked', 'some'].includes(chatmailAllCheckedSubjects)
                ? 'actions'
                : 'filters'
              }
              subjects={subjects}
              chatmailCheckedSubjects={chatmailCheckedSubjects}
              chatmailAllCheckedSubjects={chatmailAllCheckedSubjects}
              handleAllCheckedSubjects={handleAllCheckedSubjects}
              subjectsFilterOptions={subjectsFilterOptions}
              filterValues={filterValues}
              setFilterValues={setFilterValues}
              statesOptions={statesOptions}
              openOutboundAction={openOutboundAction}
              handleChangeMultipleSubjects={handleChangeMultipleSubjects}
            />
            {subjects.length ? (
              <div ref={menuRef} className='chat-composer__subjects-menu-items-container custom-scrollbar'>
                {subjects.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).map((subject, index) => (
                  <Subject
                    key={index}
                    composer={composer}
                    subject={subject}
                    statesOptions={statesOptions}
                    conversationUser={conversationUser}
                    chatmailCheckedSubjects={chatmailCheckedSubjects}
                    setChatmailCheckedSubjects={setChatmailCheckedSubjects}
                    isOpenRemoveModal={isOpenRemoveModal}
                    toggleRemoveModal={toggleRemoveModal}
                    handleSelectSubject={handleSelectSubject}
                    handleStateSubject={handleStateSubject}
                    handleReadSubject={handleReadSubject}
                    handleMnemonicSubject={handleMnemonicSubject}
                    handleDeleteSubject={handleDeleteSubject}
                    scrollToBottomMenu={() => setTimeout(() => scrollToBottom(menuRef.current))}
                  />
                ))}
                {loadingSubjects.isFetching ? (
                  <div className='chat-composer__spinner-container'>
                    <Nixi1Spinner width='20px' height='20px' />
                  </div>
                ) : (
                  !loadingSubjects.isAll ? (
                    <button
                      className='chat-composer__subjects-load-btn'
                      onClick={() => getSubjects({ userId: conversationUser.id })}
                    >
                      <figure>
                        <img
                          src={getStaticImage('/icons/orange-brand/sync-primary.svg')}
                          alt={I18n.t('dashboard_load-more')}
                        />
                      </figure>
                      <span>{I18n.t('dashboard_load-more')}</span>
                    </button>
                  ) : null
                )}
              </div>
            ) : null}
          </div>
        </ClickOutHandler>
      )}
    </div>
  )
}

export default Subjects
